// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"522":"144529bc","769":"ac2da8a3"}[chunkId] + ".chunk.js";
};